import { Route, Routes } from 'react-router';

import { Container } from './styles';

import SettingsMenu from 'src/r_page/settings/menu';
import SettingsAccount from 'src/r_page/settings/account';
import SettingsAlarm from 'src/r_page/settings/alarm';
import { BillingView } from '#views/BillingView';

export function SettingsView() {
  return (
    <Container>
      <Routes>
        <Route index element={<SettingsMenu />} />
        <Route path="account" element={<SettingsAccount />} />
        <Route path="alarm" element={<SettingsAlarm />} />
        <Route path="billing/*" element={<BillingView />} />
      </Routes>
    </Container>
  );
}
